import * as Sentry from "@sentry/react";
import { createBrowserRouter } from "react-router-dom";

import { checkIfInIframe } from "./checkIfInIframe";

const isInIframe = checkIfInIframe();

const sentryCreateBrowserRouter =
	Sentry.wrapCreateBrowserRouterV7(createBrowserRouter);

const router = sentryCreateBrowserRouter([
	{
		async lazy() {
			let { Maintenance } = await import("../pages/Maintenance");
			return {
				Component: Maintenance,
			};
		},
		children: [
			{
				async lazy() {
					let ParamAuth = await import("../components/Auth/ParamAuth");
					return {
						Component: ParamAuth.default,
					};
				},
				children: [
					{
						async lazy() {
							let NoAuthRoute = await import("../components/Auth/NoAuthRoute");
							return {
								Component: NoAuthRoute.default,
							};
						},
						children: [
							{
								path: "/",
								async lazy() {
									let AuthLayout = await import("../layouts/AuthLayout");
									return {
										Component: AuthLayout.default,
									};
								},
								children: [
									{
										path: "/",
										async lazy() {
											let Login = await import("../pages/Auth/Login");
											return {
												Component: Login.default,
											};
										},
									},
									{
										path: "register",
										async lazy() {
											let Register = await import("../pages/Auth/Register");
											return {
												Component: Register.default,
											};
										},
									},
									{
										path: "forgot-password",
										async lazy() {
											let ForgotPassword = await import(
												"../pages/Auth/ForgotPassword"
											);
											return {
												Component: ForgotPassword.default,
											};
										},
									},
									{
										path: "reset-password",
										async lazy() {
											let ResetPassword = await import(
												"../pages/Auth/ResetPassword"
											);
											return {
												Component: ResetPassword.default,
											};
										},
									},
								],
							},
						],
					},
					{
						async lazy() {
							let AuthLayout = await import("../layouts/AuthLayout");
							return {
								Component: AuthLayout.default,
							};
						},
						children: [
							{
								path: "email-update",
								async lazy() {
									let EmailUpdate = await import("../pages/Auth/EmailUpdate");
									return {
										Component: EmailUpdate.default,
									};
								},
							},
						],
					},
					{
						path: "terms-and-conditions",
						async lazy() {
							let Terms = await import("../pages/Terms");
							return {
								Component: Terms.default,
							};
						},
					},
					{
						async lazy() {
							let AuthRoute = await import("../components/Auth/AuthRoute");
							return {
								Component: AuthRoute.default,
							};
						},
						children: [
							{
								path: "/system",
								async lazy() {
									let SystemLayout = await import("../layouts/SystemLayout");
									return {
										Component: SystemLayout.default,
									};
								},
								children: [
									{
										path: "",
										async lazy() {
											let Main = await import("../pages/Dashboard/Main");
											return {
												Component: Main.default,
											};
										},
									},
									{
										path: "dashboard-charts",
										async lazy() {
											let Charts = await import("../pages/Dashboard/Chart");
											return {
												Component: Charts.default,
											};
										},
									},
									{
										path: "dashboard-trends",
										async lazy() {
											let Trends = await import("../pages/Dashboard/Trends");
											return {
												Component: Trends.default,
											};
										},
									},
									{
										path: "dashboard-income",
										async lazy() {
											let Income = await import("../pages/Dashboard/Income");
											return {
												Component: Income.default,
											};
										},
									},
									{
										path: "allegro-ads",
										async lazy() {
											let Ads = await import("../pages/Ads");
											return {
												Component: Ads.default,
											};
										},
									},
									{
										path: "logs",
										async lazy() {
											let Logs = await import("../pages/Logs");
											return {
												Component: Logs.default,
											};
										},
									},
									{
										path: "products",
										async lazy() {
											let Products = await import("../pages/Products");

											return {
												Component: Products.default,
											};
										},
									},
									{
										path: "product-tags",
										async lazy() {
											let { ProductTags } = await import(
												"../pages/ProductTags"
											);

											return {
												Component: ProductTags,
											};
										},
									},
									{
										path: "expenses",
										async lazy() {
											let { Expenses } = await import("../pages/Expenses");

											return {
												Component: Expenses,
											};
										},
									},
									{
										path: "settings",
										async lazy() {
											// old settings (needed for iframe)
											let Settings = await import("../pages/Settings");
											// new settings
											let { SettingsPage } = await import(
												"../pages/SettingsTabs"
											);

											if (isInIframe) {
												return {
													Component: Settings.default,
												};
											}

											return {
												Component: SettingsPage,
											};
										},
									},
									{
										path: "users",
										async lazy() {
											let { Users } = await import("../pages/Users");
											return {
												Component: Users,
											};
										},
									},
									{
										path: "banners",
										async lazy() {
											let { CustomBanners } = await import(
												"../pages/CustomBanners"
											);
											return {
												Component: CustomBanners,
											};
										},
									},
									{
										path: "subscription",
										async lazy() {
											let Subscription = await import("../pages/Subscription");
											return {
												Component: Subscription.default,
											};
										},
									},
									{
										path: "progress",
										async lazy() {
											let Progress = await import("../pages/Progress");
											return {
												Component: Progress.default,
											};
										},
									},
								],
							},
						],
					},
					{
						path: "*",
						async lazy() {
							let Page404 = await import("../pages/Page404");
							return {
								Component: Page404.default,
							};
						},
					},
				],
			},
		],
	},
]);

export default router;
